// @ts-ignore
import type {IOrderTrueDriverState} from "@/store/states/IOrderTrueDriverState.interface";
// @ts-ignore
import {RentComponentErrorMessages} from "../interfaces/enums/RentComponentErrorMessages.enum";

const orderTrueDriver = {
    prefix: 'trueDriver.',
    namespaced: true,
    state: <IOrderTrueDriverState>{
        id: null,
        isRentFormValid: true,
        isValidCustomRouteForm: true,
        messages: {
            validLocation: {
                state: true,
                message: RentComponentErrorMessages.MESSAGE_DESTINATION
            },
            validDate: {
                state: true,
                message: RentComponentErrorMessages.MESSAGE_DATE
            },
        },
        passengerCount: null,
        arrivalTime: null,
        arrivalDate: null,
        pickup: null,
        // customRoutes: [],
        customRoutes: [
            {
                id: 0,
                arrivalDate: null,
                arrivalTime: null,
                routePoint: null
            },
            {
                id: 1,
                arrivalTime: null,
                arrivalDate: null,
                routePoint: null
            }
        ],
        totalDistance: 0,
        totalDuration: {
            hours: 0,
            minutes: 0
        },
        selectedTravelObjective: null,
        price: 0
    },
    mutations: {
        SET_STATE_PROP_VALUE(state: IOrderTrueDriverState, payload: {prop: string, value: any}[]): void {
            for (const obj of payload) {
                if (! state.hasOwnProperty(obj.prop)) {
                    console.error('Trying to set state prop that doesn\'t exist');
                    return;
                }
            }

            for (const obj of payload) {
                const prop = obj.prop;
                let value = obj.value;

                switch (prop) {
                    case 'arrivalDate':
                        if (typeof value !== 'object') {
                            // @ts-ignore
                            value = new Date(value);
                        }
                        break;
                }

                state[prop] = value;

                localStorage.removeItem(orderTrueDriver.prefix + prop);

                if (value !== undefined) {
                    localStorage.setItem(orderTrueDriver.prefix + prop, value ? JSON.stringify(value) : value);
                }
            }
        },

        UPDATE_ARRIVAL_TIMES_CUSTOM_ROUTES(state, payload) {
            const route = state.customRoutes.find((route) => route.id === payload.id);
            route.arrivalTime = payload.arrivalTime;
            route.arrivalDate = payload.arrivalDate;

            localStorage.setItem(orderTrueDriver.prefix + 'customRoutes', JSON.stringify(state.customRoutes));
        },

        INITIALIZE_TRUE_DRIVER_ORDER_STATE(state: IOrderTrueDriverState): void {
            state['defaultState'] = {...state};

            for (const prop of Object.getOwnPropertyNames(state)) {

                let value = localStorage.getItem(orderTrueDriver.prefix + prop);

                if (prop === 'customRoutes') {
                    state[prop] = [
                        {
                            id: 0,
                            arrivalTime: state.arrivalTime,
                            arrivalDate: state.arrivalDate,
                            routePoint: state.pickup
                        },
                        {
                            id: 1,
                            arrivalTime: null,
                            arrivalDate: null,
                            routePoint: null
                        }
                    ];
                }

                if (value) {
                    value = JSON.parse(value);
                    switch (prop) {
                        case 'arrivalDate':
                            // @ts-ignore
                            value = new Date(value);
                            break;
                    }
                    state[prop] = value;
                }
            }
        },

        // INIT_TRUE_DRIVER_CUSTOM_ROUTES(state: IOrderTrueDriverState): void {
        //     for (const prop of ['customRoutes', 'arrivalDate']) {
        //
        //         let value = localStorage.getItem(orderTrueDriver.prefix + prop);
        //
        //         if (prop === 'customRoutes') {
        //             state[prop] = [
        //                 {
        //                     id: 0,
        //                     arrivalTime: state.arrivalTime,
        //                     arrivalDate: state.arrivalDate,
        //                     routePoint: state.pickup
        //                 },
        //                 {
        //                     id: 1,
        //                     arrivalTime: null,
        //                     arrivalDate: null,
        //                     routePoint: null
        //                 }
        //             ];
        //         }
        //
        //         if (value) {
        //             value = JSON.parse(value);
        //             switch (prop) {
        //                 case 'arrivalDate':
        //                     // @ts-ignore
        //                     value = new Date(value);
        //                     break;
        //             }
        //             state[prop] = value;
        //         }
        //     }
        // },

        CLEAR_STATE(state: IOrderTrueDriverState): void {
            for (const prop of Object.getOwnPropertyNames(state)) {
                localStorage.removeItem(orderTrueDriver.prefix + prop);

                if (state.defaultState) {
                    state[prop] = state.defaultState[prop];
                }
            }
        }
    },
    actions: {
        updateState(context, data: {prop: string, value: any}): void {
            context.commit('SET_STATE_PROP_VALUE', data);
        },
    },
    getters: {

    }
}

export default orderTrueDriver;